import { useTranslation } from 'react-i18next';
import { Box } from '@chakra-ui/react';

import useGetReportHelpPartner from 'Domain/report-help-partner/useGetReportHelpPartner';

import ReportHelpPartnerProvider, { useReportHelpPartnerState } from 'View/report-help-partner/state';
import Head from 'View/report-help-partner/section/head';
import Filter from 'View/report-help-partner/section/filter';
import Table from 'View/report-help-partner/section/table';

import styles from './styles.module.css';

const ReportHelpPartner = () => {
  const { t } = useTranslation('report-help-partner');
  const { filterState } = useReportHelpPartnerState();
  const { data: dataReport, isFetching } = useGetReportHelpPartner(filterState);
  return (
    <Box className={styles['report-help__container']}>
      <Head t={t}/>
      <Filter isFetching={isFetching} t={t} />
      <Table dataReport={dataReport} isFetching={isFetching} t={t} />
    </Box>
  );
};

const ReportHelpPartnerContainer = () => <ReportHelpPartnerProvider children={<ReportHelpPartner />} />;

export default ReportHelpPartnerContainer;
